import { render, staticRenderFns } from "./prizeSet.vue?vue&type=template&id=0f3ec4ca&scoped=true&"
import script from "./prizeSet.vue?vue&type=script&lang=js&"
export * from "./prizeSet.vue?vue&type=script&lang=js&"
import style0 from "./prizeSet.vue?vue&type=style&index=0&id=0f3ec4ca&prod&lang=less&scoped=true&"
import style1 from "./prizeSet.vue?vue&type=style&index=1&id=0f3ec4ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ec4ca",
  null
  
)

export default component.exports